// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { PageContent } from '@/components/page-content';
import { TicketList } from '@/ticket/components/ticket-list';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/tickets/')({
  component: TicketsRoute,
});

function TicketsRoute() {
  return (
    <PageContent>
      <TicketList />
    </PageContent>
  );
}
